import React from 'react';
import api from '../apiConnector'

import FrontRecapitulatif from './recapitulatif';
import FrontFooter from './footer'
import FrontProgress from './progress';
import FrontTarifsAlone from './tarifsAlone';
import FrontOptionsAlone from './optionsAlone'
import FrontEcheancier from './echeancier';
import error_warning from '../img/error-warning-line-yellow.png'
import FieldSelect from './fields/fieldSelect';

export default class FrontError extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {

        return <>
        <div className="container">
            <div className="contentbox front_form">
                <div className="contentvbox">
                    <h1 className="top_title" >Vous n'êtes plus connecté</h1>
                    <p className="error">
                        Pour des raisons de sécurité, vous n'êtes plus connecté à ce dossier. 
                        <br/>Merci de revenir en suivant le lien qui vous a été envoyé dans l'email du devis 
                    ou dans l'email de confirmation.</p>
                    <p className="error">N'hésitez pas à nous contacter au <br/><a href="tel:0974772861">09 74 77 28 61</a></p>
                </div>
            </div>
        </div>
        </>
    }
}